// GQL
import { client } from '../client';
import { REGENERATE_ACCESS_TOKEN } from '../mutations/auth';
export const refreshToken = async (refreshToken: string) => {
  const refreshResolverResponse = await client.mutate({
    mutation: REGENERATE_ACCESS_TOKEN,
    variables: { refreshToken },
    // 🔴 El refresco NUNCA se encola (spec 2026-10-01 § 5.2): guardaría en
    // IndexedDB un refresh token de 60 días y, con la sesión muerta, su replay
    // bloquearía la cola. Sin red falla, y la sesión se conserva.
    context: { skipOfflineQueue: true },
  });

  return refreshResolverResponse.data?.regenerateAccessToken;
};
